<template>
  <v-date-picker
      v-model="day"
      :show-current="true"
      :first-day-of-week="1"
      :events="usersSelectedEvents"
      :event-color="date => usersSelectedEventsColors[date]"
      no-title
      show-adjacent-months
      color="primary"
      full-width
      :allowed-dates="allowedDatesChecker"
      @click.native="handlePickerClick"
      scrollable
  /> 
</template>
<script>


import moment from "moment";

export default {

  props:['daySelected','usersSelectedEventsColors', 'cookieName', 'events', 'allowedDates'],
  data:()=>({
    day:moment(new Date()).format('YYYY-MM-DD'),
    cookieValue: null,
    usersSelectedEvents: []
  }),
  watch:{
    day() {
      this.$emit('update:daySelected', this.day);
      this.$cookie.set(this.cookieName, this.day, 30);
    },
    events() {
      this.usersSelectedEvents = this.events;
    },
    daySelected(){
      this.day = this.daySelected;
    }
  },
  mounted(){
    this.cookieValue = this.$cookie.get(this.cookieName);

    if (moment(this.cookieValue).isValid()) {
      this.day = this.cookieValue;
    } else if (this.daySelected) {
      this.day = this.daySelected;
    }

    if (this.events) {
      this.usersSelectedEvents = this.events;
    }

    this.$emit('update:daySelected', this.day);
  },
  methods:{
    handlePickerClick(e) {//открытие заблокированных дат из соседних месяцев (в vuetify 3 уже работает по умолчанию)
      const target = e.target;

      if (target.tagName !== 'TD') {
        return;
      }

      const parentTr = target.closest('tr');
      const trIndex = parentTr.rowIndex;
      const rowsLength = parentTr.closest('table').querySelectorAll('tr').length-1;
      console.log(trIndex,rowsLength)
      const dayText = target.querySelector('.v-btn__content').innerText;
      const day = dayText.padStart(2, '0');
      const dateStr = target.closest('.v-picker').querySelector('.v-date-picker-header__value').innerText;
      const date = moment(dateStr, "MMMM YYYY г.", 'ru');
      const monthMM = date.format('MM');
      const yearYYYY = date.format('YYYY');
      

      if (trIndex===1&&day >= 25 && day <= 31) {
          let monthYear = moment(yearYYYY+'-'+monthMM).subtract(1,'month').format('YYYY-MM')
          this.day = moment(monthYear+'-'+day).format('YYYY-MM-DD')
      } else if (trIndex===rowsLength&&day >= 1 && day <= 8) {
          this.day = moment(yearYYYY+'-'+monthMM+'-'+day).add(1,'month').format('YYYY-MM-DD')
      } else {
        return;
      }
    },
    allowedDatesChecker(val){
      if (typeof this.allowedDates === 'undefined'||this.allowedDates.includes(val)||this.allowedDates.lengt===0) return val
    },
  }
}
</script>

<style lang="scss">
  .v-date-picker-table__events {
    &>div {
      border: 1px solid #ffffff !important;
    }
  }
</style>